<nz-space class="mobile-report-control">
  <app-invoice-select [(ngModel)]="from" class="report-control" (ngModelChange)="fromChange.emit($event)"
    valueField="docCode">
  </app-invoice-select>
  <span class="text-center">
    <span nz-icon nzType="swap-right" nzTheme="outline"></span>
  </span>
  <app-invoice-select [(ngModel)]="to" class="report-control" (ngModelChange)="toChange.emit($event)"
    valueField="docCode"></app-invoice-select>
</nz-space>
